<lui-circular-progress mode="indeterminate"></lui-circular-progress>
